import React from 'react';
import PropTypes from 'prop-types';

import { MultiSelect } from '@metarouter-private/mr-mui';

import useGetClusterOptions from 'app/components/cluster-select/useGetClusterOptions';

const DEFAULT_MULTI_SELECT_PROPS = {
  size: 'small',
  variant: 'outlined',
  label: 'Cluster',
  'data-test-id': 'clusterSelect',
};

export default function ClusterMultiSelect({ setSelectedClusters, ...multiSelectProps }) {
  const clusterOptions = useGetClusterOptions();

  const finalMultiSelectProps = {
    ...DEFAULT_MULTI_SELECT_PROPS,
    ...multiSelectProps,
  };

  return <MultiSelect {...finalMultiSelectProps} options={clusterOptions} onChange={setSelectedClusters} />;
}

ClusterMultiSelect.propTypes = {
  setSelectedClusters: PropTypes.func.isRequired,
};
